import { useState } from "react";

import DOMPurify from 'dompurify';

export default function MasterclassPopup({ 
  isOpen, 
  onClose, 
  onGoNext, 
  webinarDescription,
  showCheckbox = true
}) {
  const [isChecked, setIsChecked] = useState(false);
  const [checkboxError, setCheckboxError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const cleanDescription = (html) => {
    if (!html) return '';
    const cleaned = html.replace(/\u00A0/g, ' ').replace(/&nbsp;/g, ' ');
    return DOMPurify.sanitize(cleaned);
  };

  const handleCheckboxChange = (e) => {
    setIsChecked(e?.target?.checked);
    if (e?.target?.checked) {
      setCheckboxError(false);
    }
  };

  const handleConnect = () => {
    if (showCheckbox && !isChecked) {
      setCheckboxError(true);
      return;
    }
    setIsLoading(true);
    setTimeout(() => {
      onGoNext();
      setIsLoading(false);
    }, 800);
  };

  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 bg-gray-900/60 backdrop-blur-md flex items-center justify-center z-50 p-4"
      onClick={(e) => {
        if (e?.target === e?.currentTarget && !isLoading) {
          onClose();
        }
      }}
    >
      <div className="bg-white rounded-2xl max-w-md w-full mx-auto">
        <div className="p-6 md:p-8">
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-xl md:text-2xl font-bold text-gray-800">About Ecom Event</h2>
            <button 
              onClick={onClose} 
              disabled={isLoading}
              className={`text-gray-400 hover:text-gray-600 text-2xl font-light leading-none ${isLoading ? 'cursor-not-allowed' : ''}`}
            >
              &times;
            </button>
          </div>
          
          <div className="text-gray-600 mb-6 leading-relaxed text-sm quill-html-content max-h-[45vh] overflow-y-auto overflow-x-hidden pr-1">
            {webinarDescription ? (
              <div dangerouslySetInnerHTML={{ __html: cleanDescription(webinarDescription) }} />
            ) : (
              <p>Join our comprehensive e-commerce masterclass where you'll learn everything about starting and scaling your online business. From product sourcing to marketing strategies, we cover it all with expert guidance and lifetime support.</p>
            )}
          </div>
        </div>
      </div>
      <style>{`
        .quill-html-content ul {
          list-style-type: disc !important;
          padding-left: 1.5rem !important;
          margin-bottom: 1rem !important;
        }
        .quill-html-content ol {
          list-style-type: decimal !important;
          padding-left: 1.5rem !important;
          margin-bottom: 1rem !important;
        }
        .quill-html-content li {
          margin-bottom: 0.5rem !important;
          display: list-item !important;
        }
        .quill-html-content p {
          margin-bottom: 0.75rem !important;
        }
        .quill-html-content {
          word-break: break-word !important;
          overflow-wrap: break-word !important;
        }
        .quill-html-content * {
          word-break: break-word !important;
          overflow-wrap: break-word !important;
        }
        /* Custom scrollbar for description container */
        .quill-html-content::-webkit-scrollbar {
          width: 6px;
        }
        .quill-html-content::-webkit-scrollbar-track {
          background: #f1f5f9;
          border-radius: 8px;
        }
        .quill-html-content::-webkit-scrollbar-thumb {
          background: #cbd5e1;
          border-radius: 8px;
        }
        .quill-html-content::-webkit-scrollbar-thumb:hover {
          background: #94a3b8;
        }
        .quill-html-content {
          -ms-overflow-style: auto;  /* IE and Edge */
          scrollbar-width: thin;  /* Firefox */
          scrollbar-color: #cbd5e1 #f1f5f9; /* Firefox */
        }
      `}</style>
    </div>
  );
}